import { IFunctionCard } from '@/pages/home/interface/home.interface';
import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';
import { FUNC_HASH_CONV } from '@/pages/function/constants/index';
import { CONVENIENCE_CARDS } from '../constants';

interface ConvenienceCardProps {
	items: IFunctionCard[];
}

/**
 * 올인원 비즈니스웨어 스타트업, 성장기업을 위해 최적화된 ERP 스텔라 편의 기능 카드 컴포넌트
 * @param props: IFunctionCard
 * @returns JSX.Element
 */

const ConvenienceCard = ({ items }: ConvenienceCardProps) => {
	const item = CONVENIENCE_CARDS;
	return (
		<>
			{item.map((card, index) => (
				<li key={index} className="card-item">
					<Link to={`${NAV_PATH.FUNCTION.CONVENIENCE}#${card.type}`}>
						<div className={`icon-holder ${card.icoNum}`}>
							<i></i>
						</div>
						<div className="title-group">
							<strong className={`title ${card.new ? 'new' : ''}`}>{card.title}</strong>
							<p className="desc" dangerouslySetInnerHTML={{ __html: card.description }}></p>
						</div>
					</Link>
				</li>
			))}
		</>
	);
};

export default ConvenienceCard;
